import { render, staticRenderFns } from "./SummaryItem.vue?vue&type=template&id=3afb7c4a&"
import script from "./SummaryItem.vue?vue&type=script&lang=js&"
export * from "./SummaryItem.vue?vue&type=script&lang=js&"
import style0 from "./SummaryItem.vue?vue&type=style&index=0&id=3afb7c4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports